import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import Request from '../../../../helpers/request'
import * as url from '../../../../helpers/url_helper'

const ProfileList = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        Request.post(url.GET_USERS_DETAIL_URL, { userId: id, roomId: '' })
            .then((res: any) => {
                const places = res.data?.places
                if (places?.length > 0) {
                    navigate(`/users/profile/${id}/places/${places[0].id}/overview`, { replace: true })
                } else {
                    toast.error('No places found for this user')
                }
            })
            .catch(() => {
                toast.error('Failed to load profile')
                setLoading(false)
            })
    }, [id])

    return (
        <React.Fragment>
            <ToastContainer />
            {loading && (
                <div className="page-content" style={{ textAlign: 'center', marginTop: 60 }}>
                    <p style={{ color: '#858D9D' }}>Loading...</p>
                </div>
            )}
        </React.Fragment>
    )
}

export default ProfileList
